// extracted by mini-css-extract-plugin
export default {"container":"TecnicosPage_container__ObRrU","containerOne":"TecnicosPage_containerOne__ehGHp","header":"TecnicosPage_header__BvmW4","cards":"TecnicosPage_cards__67CNj"};